export default class InternetExplorerHelper {
  private static clientStrings = [
    { platform: `windows_8.1`, regex: /(Windows 8.1|Windows NT 6.3)/ },
    { platform: `windows_8`, regex: /(Windows 8|Windows NT 6.2)/ },
    { platform: `windows_7`, regex: /(Windows 7|Windows NT 6.1)/ },
    { platform: `windows_Vista`, regex: /Windows NT 6.0/ },
    { platform: `windows_Server 2003`, regex: /Windows NT 5.2/ },
    { platform: `windows_XP`, regex: /(Windows NT 5.1|Windows XP)/ },
    { platform: `windows_2000`, regex: /(Windows NT 5.0|Windows 2000)/ },
    { platform: `windows_ME`, regex: /(Win 9x 4.90|Windows ME)/ },
    { platform: `windows_98`, regex: /(Windows 98|Win98)/ },
    { platform: `windows_95`, regex: /(Windows 95|Win95|Windows_95)/ },
    { platform: `windows_NT_4.0`, regex: /(Windows NT 4.0|WinNT4.0)/ },
    { platform: `windows_CE`, regex: /Windows CE/ },
    { platform: `windows_3.11`, regex: /Win16/ },
  ];

  public static isOldWindows(): boolean {
    const { userAgent } = navigator;
    if(userAgent) {
      for(const cs of this.clientStrings) {
        if(cs.regex.test(userAgent)) {
          return true;
        }
      }
    }
    return false;
  }

  public static isInternetExplorer(): boolean {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf(`MSIE `);
    const trident = ua.indexOf(`Trident/`);
    return msie > 0 || trident > 0;
  }
}
